/* ══════════════════════════════════════════════════════════════════════
   ÁGUAS DE IPANEMA — GLOBAL VIDEO LOADING RULE
   Carregamento tardio de TODOS os vídeos do site (atuais e futuros).

   <video> não tem loading="lazy". Este helper, carregado no theme.liquid:
   1. Para cada <video> que NÃO está na primeira tela ao carregar (hero/LCP
      é exceção documentada): tira src/<source src> → data-src, força
      preload="none", remove autoplay (guardado em data-aip-autoplay) e
      aborta o download já iniciado (load()).
   2. Um IntersectionObserver (rootMargin 320px) devolve o src quando o
      vídeo se aproxima da viewport; se era autoplay, dá play mudo/inline.
   3. Vídeos em autoplay pausam ao sair da viewport e retomam ao voltar.
   4. iframes YouTube/Vimeo fora da primeira tela só recebem o src ao se
      aproximar da viewport.
   5. MutationObserver + shopify:section:load cobrem vídeos inseridos
      depois (Theme Editor, seções carregadas por AJAX).
   Componentes com estratégia própria são respeitados: data-src já
   presente, data-fvs-video (vídeos shoppable), data-vcar-vid, ou
   data-aip-no-lazy.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__aipVideoLazy) return;
  window.__aipVideoLazy = true;

  var TEM_IO = 'IntersectionObserver' in window;
  var MARGEM = '320px 0px';

  function naPrimeiraTela(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  /* pausa fora da viewport / retoma ao voltar (só para quem estava tocando) */
  var ioPausa = TEM_IO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var v = e.target;
      if (!e.isIntersecting) {
        if (!v.paused && !v.ended) { v.__aipPausadoFora = true; v.pause(); }
      } else if (v.__aipPausadoFora) {
        v.__aipPausadoFora = false;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      }
    });
  }, { threshold: 0.01 }) : null;

  function vigiarPausa(v) {
    if (v.__aipVigiado || !ioPausa) return;
    v.__aipVigiado = true;
    ioPausa.observe(v);
  }

  function ligar(v) {
    if (v.__aipLigado) return;
    v.__aipLigado = true;
    var src = v.getAttribute('data-src');
    if (src) v.setAttribute('src', src);
    v.querySelectorAll('source[data-src]').forEach(function (s) {
      s.setAttribute('src', s.getAttribute('data-src'));
    });
    if (v.getAttribute('data-aip-preload')) v.setAttribute('preload', v.getAttribute('data-aip-preload'));
    try { v.load(); } catch (e) {}
    if (v.getAttribute('data-aip-autoplay') === '1') {
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.setAttribute('autoplay', '');
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    }
    vigiarPausa(v);
  }

  var ioCarga = TEM_IO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) { ligar(e.target); ioCarga.unobserve(e.target); }
    });
  }, { rootMargin: MARGEM }) : null;

  function preparar(v) {
    if (v.__aipPreparado) return;
    v.__aipPreparado = true;

    var proprio = v.hasAttribute('data-aip-no-lazy') || v.hasAttribute('data-fvs-video') ||
                  v.hasAttribute('data-vcar-vid');
    if (proprio) return;

    /* já veio no padrão data-src (snippet aip-video ou hero lazy): só observar */
    var jaLazy = v.hasAttribute('data-src') || v.querySelector('source[data-src]');

    if (!jaLazy) {
      /* primeira tela (hero / LCP) = exceção: carrega normalmente, só vigia pausa */
      if (naPrimeiraTela(v)) { vigiarPausa(v); return; }
      if (!TEM_IO) { vigiarPausa(v); return; }
      var src = v.getAttribute('src');
      if (src) { v.setAttribute('data-src', src); v.removeAttribute('src'); }
      v.querySelectorAll('source[src]').forEach(function (s) {
        s.setAttribute('data-src', s.getAttribute('src')); s.removeAttribute('src');
      });
      if (v.autoplay || v.hasAttribute('autoplay')) { v.setAttribute('data-aip-autoplay', '1'); v.removeAttribute('autoplay'); v.autoplay = false; }
      var pre = v.getAttribute('preload');
      if (pre && pre !== 'none') v.setAttribute('data-aip-preload', pre);
      v.setAttribute('preload', 'none');
      try { v.load(); } catch (e) {}   /* aborta download já iniciado */
    } else if (!v.getAttribute('data-aip-autoplay') && (v.autoplay || v.hasAttribute('autoplay'))) {
      v.setAttribute('data-aip-autoplay', '1'); v.removeAttribute('autoplay'); v.autoplay = false;
    }

    if (!TEM_IO) { ligar(v); return; }
    ioCarga.observe(v);
  }

  /* iframes de YouTube / Vimeo fora da primeira tela */
  var ioFrame = TEM_IO ? new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (!e.isIntersecting) return;
      var f = e.target;
      if (f.getAttribute('data-src')) { f.setAttribute('src', f.getAttribute('data-src')); f.removeAttribute('data-src'); }
      ioFrame.unobserve(f);
    });
  }, { rootMargin: MARGEM }) : null;

  function prepararFrame(f) {
    if (f.__aipPreparado || !ioFrame) return;
    f.__aipPreparado = true;
    var src = f.getAttribute('src') || '';
    if (!/youtube|youtu\.be|vimeo/i.test(src) || f.hasAttribute('data-aip-no-lazy')) return;
    if (naPrimeiraTela(f)) return;
    f.setAttribute('data-src', src);
    f.setAttribute('src', 'about:blank');
    ioFrame.observe(f);
  }

  function varrer(raiz) {
    (raiz || document).querySelectorAll('video').forEach(preparar);
    (raiz || document).querySelectorAll('iframe[src]').forEach(prepararFrame);
  }

  function iniciar() {
    varrer(document);
    if ('MutationObserver' in window) {
      new MutationObserver(function (ms) {
        ms.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches('video')) preparar(n);
            if (n.matches && n.matches('iframe[src]')) prepararFrame(n);
            if (n.querySelectorAll) varrer(n);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function (e) { varrer(e.target); });
    /* Aba em segundo plano: o navegador recusa o play() enquanto a aba está
       oculta. Ao voltar, retoma os autoplay já ligados que estão na tela. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      document.querySelectorAll('video[data-aip-autoplay="1"]').forEach(function (v) {
        if (!v.__aipLigado || !v.paused || v.ended || v.__aipPausadoFora) return;
        var r = v.getBoundingClientRect();
        if (r.bottom <= 0 || r.top >= (window.innerHeight || 0)) return;
        v.muted = true;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
